__webpack_require__.v = (exports, wasmModuleId, wasmModuleHash, importsObj) => {

	return new Promise(function (resolve, reject) {
		try {
			var { readFile } = require('fs');
			var { join } = require('path');

			readFile(join(__dirname, "" + wasmModuleHash + ".module.wasm"), function(err, buffer){
				if (err) return reject(err);

				// Fake fetch response
				resolve({
					arrayBuffer() { return buffer; }
				});
			});
		} catch (err) { reject(err); }
	})
		.then((x) => (x.arrayBuffer()))
		.then((bytes) => (WebAssembly.instantiate(bytes, importsObj)))
		.then((res) => (Object.assign(exports, res.instance.exports)));
};